<template>
  <div :class="$options.name" v-bind="$attrs">
    <slot />
  </div>
</template>
<script lang="ts">
import { lateinit } from 'tg-commons'
import { ElementOverlay, LatLng, MapPane, unwrapStringEnumValue, type BaseMap, type ElementOverlayOptions, type OverlayProjection, type WrapStringEnumValue } from 'tg-map-core'
import { defineComponent } from 'vue'
import { requiredProp, stringEnumProp, type Props } from '../../utils/vue-utils'
import MapMixin from '../map-mixin'

/** ElementOverlay的简单实现 */
class SimpleElementOverlay extends ElementOverlay {
  constructor(
    map: BaseMap,
    options: ElementOverlayOptions,
    public content: HTMLElement,
    private position: LatLng,
  ) {
    super(map, options)
  }
  protected onCreate(): HTMLElement {
    return this.content
  }
  protected onDraw(projection: OverlayProjection): void {
    const point = projection.fromLatLngToOverlayPoint(this.position)
    this.content.style.left = point.x + 'px'
    this.content.style.top = point.y + 'px'
  }
  setPosition(position: LatLng) {
    this.position = position
    this.draw()
  }
}

const TgElementOverlay = defineComponent({
  name: 'tg-element-overlay',
  mixins: [MapMixin],
  props: {
    mapPane: stringEnumProp(MapPane, MapPane.overlayMouseTarget),
    position: requiredProp(LatLng),
  } satisfies Props<WrapStringEnumValue<ElementOverlayOptions, {
    mapPane: typeof MapPane,
  }> & { position: LatLng }>,
  setup() {
    return {
      overlay: lateinit<SimpleElementOverlay>(),
    }
  },
  watch: {
    position(value) {
      this.overlay.setPosition(value)
    },
    mapPane() {
      this.recreate()
    },
  },
  methods: {
    content(): HTMLElement {
      return this.$el as HTMLElement
    },
  },
  onCreate() {
    this.overlay = new SimpleElementOverlay(this.$map, unwrapStringEnumValue(this), this.content(), this.position)
    this.$map.addElementOverlay(this.overlay)
  },
  onDestroy() {
    this.$map.removeElementOverlay(this.overlay)
  },
})
type TgElementOverlay = InstanceType<typeof TgElementOverlay>
export default TgElementOverlay
</script>
<style lang="scss">
// 只有移到.tg-map__map里面时才显示
.tg-map .tg-element-overlay {
  display: none;
}
.tg-map__map .tg-element-overlay {
  display: block;
}
</style>
